import Toast from 'components/toasts/Toast';
import { getIsAuthenticated, getUserId } from 'features/customer/store/selectors';
import { getWorkspaceId as getWorkspaceIdUtil } from 'features/workspaces/getWorkspaceId';
import { getWorkspaceId } from 'features/workspaces/workspaceSlice';
import { RootState } from 'store/rootReducer';
import { call, put, select, takeLatest } from 'typed-redux-saga';
import { reportErrors } from 'utils/reportErrors';

function* getWorkspaceIdSaga() {
  try {
    const customerId = yield* select(getUserId);
    const isAuthenticated = yield* select(getIsAuthenticated);
    const currentSelectedWorkspaceId = yield* select(
      (state: RootState) => state.workspace.workspaceId
    );

    if (!isAuthenticated || !customerId) {
      yield* put(getWorkspaceId.failure());
      return;
    }

    const workspaceId: string | null = yield* call(
      getWorkspaceIdUtil,
      customerId,
      currentSelectedWorkspaceId
    );
    yield* put(getWorkspaceId.success(workspaceId));
  } catch (error) {
    yield* put(getWorkspaceId.failure());
    Toast.apiError();
    reportErrors('saga', error as Error);
  }
}

export const workspaceSagas = [takeLatest(getWorkspaceId.request.toString(), getWorkspaceIdSaga)];
